<nz-layout>
    <nz-content>
        <div class="header">
            <label>Category:&nbsp;</label>
            <nz-select
                [(ngModel)]="category"
                [nzLoading]="isLoadingCategories"
                nzSize="large"
                style="width: 150px"
            >
                <nz-option
                    *ngFor="let c of categories"
                    [nzValue]="c.id"
                    [nzLabel]="c.name"
                ></nz-option>
            </nz-select>

            <jackhealth-admin-product-selector
                [category]="category"
                (productSelected)="onProductSelected($any($event))"
            ></jackhealth-admin-product-selector>
        </div>
        <form [formGroup]="orderForm">
            <div formArrayName="items">
                <nz-table
                    #basicTable
                    [nzData]="items.controls"
                    [nzLoading]="isLoading"
                    [nzShowPagination]="false"
                >
                    <thead>
                        <tr>
                            <th class="w-full">Product</th>
                            <th class="w-16">Variant</th>
                            <th class="w-5">Qty</th>
                            <th class="w-12">Unit Price</th>
                            <th class="w-12">Subtotal</th>
                            <th class="w-8"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container
                            [formGroupName]="i"
                            *ngFor="let item of basicTable.data; let i = index"
                        >
                            <tr>
                                <td class="w-full">
                                    <div class="flex flex-col">
                                        <span class="font-semibold">
                                            {{ item.value.name }}
                                        </span>
                                        <span
                                            *ngIf="item.value.subLabel"
                                            class="text-sm text-gray-500"
                                        >
                                            {{ item.value.subLabel }}
                                        </span>
                                    </div>
                                </td>
                                <td class="w-16">
                                    <portals-emr-variant-select
                                        [productId]="item.value.productId"
                                        [variantId]="item.value.variantId"
                                        (selectedVariant)="
                                            onVariantChange(item, $event)
                                        "
                                    ></portals-emr-variant-select>
                                </td>
                                <td class="w-5">
                                    <input
                                        nz-input
                                        formControlName="quantity"
                                        type="number"
                                    />
                                </td>
                                <td class="w-12">
                                    <input
                                        nz-input
                                        formControlName="salePrice"
                                        type="number"
                                    />
                                </td>
                                <td class="w-12">
                                    {{
                                        item.get('quantity').value *
                                            item.get('salePrice').value
                                    }}
                                </td>
                                <td class="w-8">
                                    <a
                                        href="javascript:void(0)"
                                        (click)="removeProduct(i)"
                                    >
                                        <i class="fa-solid fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </nz-table>
            </div>
        </form>
    </nz-content>
    <nz-footer>
        <button nz-button nzType="primary" (click)="submit()">
            Create Order
        </button>
        <h3 class="error">{{ error }}</h3>
    </nz-footer>
</nz-layout>
